export const MuiBreadcrumbs = (gray300:string, gray600:string, primary700:string, 
  fontweightRegular:number, fontweightMedium: number, fontWeightSemiBold: number ) => ({
  defaultProps: {
    separator: '>',
  },
  styleOverrides: {
    root: {
      '& .MuiBreadcrumbs-separator': {
        color: gray300,
      },
      '& .MuiBreadcrumbs-li:last-child, & .MuiBreadcrumbs-li:last-child .MuiTypography-root': {
        color: primary700, 
        fontWeight: fontWeightSemiBold, 
      },
      '& a': {
        color: gray600, // Text black only within breadcrumbs
        textDecoration: 'none',
        fontWeight: fontweightRegular, // Light font weight for links
        '&:hover': {
          textDecoration: 'underline',
          fontWeight: fontweightMedium,
        },
      },
    },
  },
});